/* eslint-disable func-names */
import Siema from 'siema';
import '../polyfills/closest';

// sliders
const informationSliders = [...document.querySelectorAll('.js-informationSlider')];

if (informationSliders.length > 0) {
  informationSliders.forEach(function applySlider(informationSlider) {
    const slides = [...informationSlider.querySelectorAll('.js-informationSlide')];

    const imageWrapper = informationSlider
      .closest('.js-informationSliderParent')
      .querySelector('.js-informationSliderPhotoWrapper');

    const buttonPrev = informationSlider
      .closest('.js-informationSliderParent')
      .querySelector('.js-informationSliderNavPrev');

    const buttonNext = informationSlider
      .closest('.js-informationSliderParent')
      .querySelector('.js-informationSliderNavNext');

    const buttonNavs = [
      ...informationSlider
        .closest('.js-informationSliderParent')
        .querySelectorAll('.js-informationSliderNavButton'),
    ];

    const slider = new Siema({
      selector: informationSlider,
      duration: 0,
      easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
      loop: true,
      onChange() {
        const currentSlideElement = slides[slider.currentSlide];
        const slideImage = currentSlideElement.dataset.associatedPhoto;

        slides.forEach(slide => {
          slide.classList.remove('-active');
        });

        buttonNavs.forEach(buttonNav => {
          buttonNav.classList.remove('-active');
        });

        buttonNavs[slider.currentSlide].classList.add('-active');
        slides[slider.currentSlide].classList.add('-active');

        // eslint-disable-next-line prefer-const
        let image = informationSlider
          .closest('.js-informationSliderParent')
          .querySelector('.js-informationSliderPhoto');

        const newImage = image.cloneNode(false);
        newImage.setAttribute('data-src', slideImage);
        newImage.classList.remove('lazyloaded');
        newImage.classList.add('lazyload');

        imageWrapper.appendChild(newImage);

        setTimeout(() => {
          image.remove();
        }, 1000);
      },
    });

    buttonPrev.addEventListener('click', () => {
      slider.prev(1);
    });

    buttonNext.addEventListener('click', () => {
      slider.next(1);
    });

    buttonNavs.forEach(buttonNav => {
      buttonNav.addEventListener('click', () => {
        const navIndex = buttonNav.dataset.index * 1;

        slider.goTo(navIndex);
      });
    });
  });
}
